var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11842_109351)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5 21.334H40.5257",
    stroke: "#9099A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.8334 10.666H19.1667C14.7485 10.666 11.1667 14.2477 11.1667 18.666V45.3327C11.1667 49.751 14.7485 53.3327 19.1667 53.3327H45.8334C50.2517 53.3327 53.8334 49.751 53.8334 45.3327V18.666C53.8334 14.2477 50.2517 10.666 45.8334 10.666Z",
    stroke: "#9099A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.1667 39.9999L21.8334 29.3332C23.0496 28.163 24.4291 27.5469 25.8334 27.5469C27.2377 27.5469 28.6173 28.163 29.8334 29.3332L43.1667 42.6665",
    stroke: "#9099A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.8333 37.3339L40.4999 34.6672C41.7161 33.4969 43.0956 32.8809 44.4999 32.8809C45.9042 32.8809 47.2838 33.4969 48.4999 34.6672L53.8333 40.0005",
    stroke: "#9099A8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11842_109351"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholder);
export default __webpack_public_path__ + "static/media/placeholder.560873d3b48a423dbfadbd27f0c3bfff.svg";
export { ForwardRef as ReactComponent };